import { createSelector } from '@ngrx/store';
import { uiFeature } from './ui.feature';

export const selectSidebarCollapsed = createSelector(
  uiFeature.selectUiState,
  (state) => state.sidebarCollapsed,
);
